import * as React from 'react';

import { SUGGEST_DESKTOP_LISTBOX_HEIGHT } from '../../constants';

import styles from './styles.module.css';

export const SuggestDesktopList = React.forwardRef<HTMLUListElement, React.PropsWithChildren<{ listHeight?: number }>>(
  (props, ref) => {
    const listHeight = props.listHeight ?? SUGGEST_DESKTOP_LISTBOX_HEIGHT;

    return (
      <ul
        ref={ref}
        role="listbox"
        className={styles['list']}
        style={{ height: listHeight, maxHeight: listHeight }}
        data-testid="suggest-desktop-list"
      >
        {props.children}
      </ul>
    );
  },
);

SuggestDesktopList.displayName = 'SuggestDesktopList';
